import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: 'logo text date';
  grid-column-gap: 0.5rem;
`;
